export default "__VITE_PUBLIC_ASSET__15e41169__"